module.exports = __webpack_public_path__ + "static/media/bq.fda6c02c.svg";